module.exports = __webpack_public_path__ + "img/banner.6d7e1771.png";